// Product analytics: batched to /api/analytics/events. The server keeps the
// funnel events (session_start, book_open, play, paywall_view, …) per account.
const eventQueue: Array<{ name: string; props?: Record<string, unknown>; ts: number }> = [];
let flushTimer: ReturnType<typeof setTimeout> | null = null;

export function flushEvents() {
  if (eventQueue.length === 0) return;
  const batch = eventQueue.splice(0, 50);
  try {
    // sendBeacon can't set headers, so the token rides in the body.
    const token = localStorage.getItem('wallos_auth_token');
    const body = JSON.stringify({ events: batch, token: token || undefined });
    const sent = navigator.sendBeacon?.('/api/analytics/events', new Blob([body], { type: 'application/json' }));
    if (!sent) {
      fetch('/api/analytics/events', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    /* analytics never breaks the app */
  }
}

export function trackEvent(name: string, props?: Record<string, unknown>) {
  eventQueue.push({ name, props, ts: Date.now() });
  if (flushTimer) clearTimeout(flushTimer);
  flushTimer = setTimeout(flushEvents, 5000);

  if (typeof window !== 'undefined' && (window as any).__wallos_analytics) {
    (window as any).__wallos_analytics.capture(name, props);
  }
  if (import.meta.env?.DEV) {
    console.debug(`[Analytics] ${name}`, props || '');
  }
}

if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', flushEvents);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flushEvents();
  });
}
